import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { DropdownSelect } from '../dropdown-select/DropdownSelect';
import { useDictionaryTranslation } from '../../hooks/useDictionaryTranslation';
import { InteroperableDataService } from '../../services/interoperableDataService';

export const SelectScholarlyLevel = ({
  selectedScholarlyLevel,
  onChange,
  disabled,
  placeholder = 'scholarlyLevelPlaceholder',
}) => {
  const { translate: t } = useDictionaryTranslation();
  const [scholarlyLevels, setScholarlyLevels] = useState([]);
  const [loading, setLoading] = useState(false);

  const selectScholarlyLevel = (item) => {
    const scholarlyLevel = scholarlyLevels.find((dt) => dt.value === item?.value);
    onChange(scholarlyLevel);
  };

  const getScholarlyLevels = useCallback(async (search) => {
    setLoading(true);
    try {
      const params = { search };
      const { scholarlyLevels: scholarlyLevelsList } = await InteroperableDataService.getScholarlyLevels(params);
      setScholarlyLevels(scholarlyLevelsList);
    } catch (error) {
      setScholarlyLevels([]);
    } finally {
      setLoading(false);
    }
  }, []);

  const getOptionData = useCallback((scholarlyLevel) => {
    return {
      value: scholarlyLevel.value,
      label: scholarlyLevel.description,
    };
  }, []);

  return (
    <DropdownSelect
      placeholderText={t(placeholder)}
      isLoading={loading}
      onChange={selectScholarlyLevel}
      options={scholarlyLevels}
      value={selectedScholarlyLevel}
      onSearch={getScholarlyLevels}
      getOptionData={getOptionData}
      disabled={disabled}
    />
  );
};

SelectScholarlyLevel.propTypes = {
  selectedScholarlyLevel: PropTypes.shape({
    value: PropTypes.string,
    description: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
};
